<template>
    <div>
        <el-time-select
            v-if="hourformat === '24'"
            :placeholder="$t.__('common.labels.hour')"
            v-model="localValue"
            :picker-options="selectOptions"
        >
        </el-time-select>
        <el-time-picker
            v-if="hourformat === '12'"
            :placeholder="$t.__('common.labels.hour')"
            v-model="localValue"
            value-format="HH:mm"
            format="hh:mm A"
            :picker-options="pickerOptions"
        >
        </el-time-picker>
    </div>
</template>

<script>
import CfMixin from 'mixins/CustomfieldsMixins';
import { createNamespacedHelpers } from 'vuex';

const corpMapState = createNamespacedHelpers('corp').mapState;

export default {
    mixins: [CfMixin],
    data() {
        return {
            selectOptions: {
                start:
                    !_.isNil(this.parameters.min_hour) && this.parameters.min_hour != ''
                        ? this.parameters.min_hour
                        : '00:00',
                step: '00:05',
                end:
                    !_.isNil(this.parameters.max_hour) && this.parameters.max_hour != ''
                        ? this.parameters.max_hour
                        : '23:55',
            },
            pickerOptions: {
                format: 'hh:mm A',
                selectableRange: `${
                    !_.isNil(this.parameters.min_hour)
                        ? moment(this.parameters.min_hour.toUpperCase(), 'hh:mm A').format(
                              'HH:mm:ss',
                          )
                        : '00:00:00'
                } - ${
                    !_.isNil(this.parameters.max_hour)
                        ? moment(this.parameters.max_hour.toUpperCase(), 'hh:mm A').format(
                              'HH:mm:ss',
                          )
                        : '23:55:00'
                }`,
            },
        };
    },
    computed: {
        ...corpMapState(['hourformat']),
        localValue: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', { id: this.id, value });
            },
        },
        isAMPM() {
            return this.hourformat === '12';
        },
    },
};
</script>
